import { useMutation } from '@tanstack/react-query';
import { quotationRepository } from '../../repositories/quotation-repository';
import { Quote } from '../../models/quotation';

export const useQuotationFull = () => {
  const validateRecaptchaQuick = async (data: Quote) => {
    return quotationRepository.quote(data);
  };

  return useMutation(async (data: Quote) => await validateRecaptchaQuick(data));
};
